import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress benign ResizeObserver loop error (caused by React Flow NodeResizer)
// This is a known non-critical browser warning, not an actual application error
const suppressResizeObserver = (e) => {
  if (e.message && e.message.includes('ResizeObserver loop')) {
    e.stopImmediatePropagation();
    e.stopPropagation();
    return;
  }
};
window.addEventListener('error', suppressResizeObserver);
window.addEventListener('unhandledrejection', (e) => {
  if (e.reason?.message?.includes?.('ResizeObserver loop')) {
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
// NOTE: React.StrictMode is intentionally OFF here. In dev it double-invokes
// effects and duplicates network requests (e.g. /api/lom/bridges, /api/lom/rails-metros),
// which wastes bandwidth and muddies profiling. Production behavior is unaffected.
root.render(<App />);
